import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IVendor, IVendorsContact } from "./vendors.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";
import { AuthService } from "../../../shared/services/auth.service";

@Injectable()
export class VendorsService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService,
  ) { }

  getVendors(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_VENDORS)}${queryParams}`);
  }

  getVendor(vendor: IVendor | string): Observable<any> {
    let id = (typeof vendor == 'string') ? vendor : vendor._id;
    return this._http.get(`${apiURL(EnvConfig.API_VENDORS)}/${id}`);
  }

  createVendor(vendor: IVendor): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_VENDORS)}`, vendor);
  }

  updateVendor(vendor: IVendor): Observable<any> {
    let id = vendor._id;
    delete vendor._id;
    return this._http.patch(`${apiURL(EnvConfig.API_VENDORS)}/${id}`, vendor);
  }

  deleteVendor(vendor: IVendor | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof vendor == 'string') ? vendor : vendor._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_VENDORS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_VENDORS)}/${id}/delete`);
  }

  restoreVendor(vendor: IVendor | string): Observable<void> {
    let id = (typeof vendor == 'string') ? vendor : vendor._id;
    return this._http.post(`${apiURL(EnvConfig.API_VENDORS)}/${id}/restore`, null);
  }

  // --------------------------
  // usa la entidad client contact
  createVendorContact(contact: IVendorsContact): Observable<IVendorsContact> {
    let data: any = _.cloneDeep(contact);
    data.company = this._AuthService.companyId();
    return this._http.post(`${apiURL(EnvConfig.API_CLIENT_CONTACTS)}`, data);
  }

  // --------------------------
  // usa la entidad client contact
  updateVendorContact(contact: IVendorsContact): Observable<any> {
    let id = contact._id;
    let data: any = _.cloneDeep(contact);
    delete data._id;
    data.company = this._AuthService.companyId();
    return this._http.patch(`${apiURL(EnvConfig.API_CLIENT_CONTACTS)}/${id}`, data);
  }
}